import { gql } from "@apollo/client";
import {
  ADDRESS_FRAGMENT,
  CCMS_SUSPENSION_FRAGMENT,
  MEMBERSHIP_BAND_FRAGMENT,
  PERSON_DETAILS_FRAGMENT,
  PHONE_NUMBER_FRAGMENT
} from "@/fragments";

export const PERSON_SIDE_SHEET_QUERY = gql`
  query PersonSideSheet($pgaId: ID!) {
    person(pgaId: $pgaId) {
      ...PersonDetailsFragment
      age
      membershipSince
      totalJobApplications
      totalActiveJobApplications
    }
  }
  ${PERSON_DETAILS_FRAGMENT}
`;

export const PERSON_SIDE_SHEET_GROUPS_QUERY = gql`
  query PersonSideSheetGroups($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      groupAssignments {
        id
        startedAt
        expiresAt
        group {
          id
          name
        }
      }
    }
  }
`;

export const PERSON_SIDE_SHEET_EDUCATION_QUERY = gql`
  query PersonSideSheetEducation($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      university {
        id
        name
      }
    }
  }
`;

export const PERSON_SIDE_SHEET_MEMBERSHIP_QUERY = gql`
  query PersonSideSheetMembership($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      latestProgram {
        id
        status
        programType {
          id
          name
        }
        band {
          ...MembershipBandFragment
        }
      }
      ccmsSuspensions {
        ...CcmsSuspensionFragment
      }
    }
  }
  ${MEMBERSHIP_BAND_FRAGMENT}
  ${CCMS_SUSPENSION_FRAGMENT}
`;

export const PERSON_SIDE_SHEET_CAREER_QUERY = gql`
  query PersonSideSheetCareer($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      employments {
        id
        endedOn
        startedOn
        isPrimary
        title
        formattedTitle
        jobClassification
        facility {
          id
          name
          addresses {
            id
            address1
            address2
            city
            state
            postalCode
            countryCode
            isVerified
            addressType
          }
          phone {
            id
            phoneFormatted
          }
          section {
            id
            name
          }
        }
      }
    }
  }
`;

export const PERSON_SIDE_SHEET_CONTACT_QUERY = gql`
  query PersonSideSheetContact($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      email
      phoneNumbers {
        ...PhoneNumberFragment
      }
      addresses {
        ...AddressFragment
      }
      age
      dob {
        day
        month
        year
      }
      gender
    }
  }
  ${PHONE_NUMBER_FRAGMENT}
  ${ADDRESS_FRAGMENT}
`;
